export interface StorageProvider {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

class MemoryStorage implements StorageProvider {
  private cache: Record<string, string> = {};

  getItem(key: string): string | null {
    return this.cache[key] ?? null;
  }

  setItem(key: string, value: string): void {
    this.cache[key] = value;
  }

  removeItem(key: string): void {
    delete this.cache[key];
  }
}

class LocalStorageWrapper implements StorageProvider {
  getItem(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  setItem(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Quota exceeded or disabled
    }
  }

  removeItem(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // Ignore
    }
  }
}

// Simple cookie fallback could be added here, but localStorage is standard for modern web SDKs.
// We'll stick to localStorage + Memory fallback.

export function getStorage(): StorageProvider {
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      window.localStorage.setItem("test", "test");
      window.localStorage.removeItem("test");
      return new LocalStorageWrapper();
    } catch {
      return new MemoryStorage();
    }
  }
  return new MemoryStorage();
}
